import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, Caption, H5, H6 } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled, { useTheme } from 'styled-components';

import useWindowSize from '@/hooks/useWindowSize';
import { useAppSelector } from '@/redux/hooks';
import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';
import { getManageCategoryNotificationsUrl } from '@/utils/urls';

import TableRow from './TableRow';

const ManageCategoryNotifications = () => {
    const bidderEmail = useAppSelector(getBidderEmail);

    const { width } = useWindowSize();
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = useTheme();
    return (
        <StyledTableRow
            email={
                <Link
                    target="_blank"
                    to={getManageCategoryNotificationsUrl(bidderEmail)}
                >
                    <FormattedMessage id="notificationsPage.table.managePreferencesRow.link" />
                </Link>
            }
            frequency={
                width > tabletNarrowWidthNum && (
                    <FormattedMessage id="notificationsPage.table.managePreferencesRow.frequency" />
                )
            }
            type={
                <>
                    {width > tabletNarrowWidthNum ? (
                        <H5>
                            <FormattedMessage id="notificationsPage.table.managePreferencesRow.title" />
                        </H5>
                    ) : (
                        <H6>
                            <FormattedMessage id="notificationsPage.table.managePreferencesRow.title" />
                        </H6>
                    )}
                    {width <= tabletNarrowWidthNum ? (
                        <Caption>
                            <FormattedMessage id="notificationsPage.table.managePreferencesRow.description" />
                        </Caption>
                    ) : (
                        <BodySecondary color="secondary">
                            <FormattedMessage id="notificationsPage.table.managePreferencesRow.description" />
                        </BodySecondary>
                    )}
                </>
            }
        />
    );
};

const StyledTableRow = styled(TableRow)`
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        > :nth-child(1) {
            grid-column: 1 / 5;
        }
    }
`;

export default ManageCategoryNotifications;
